<template>
  <div class="pg-layout-main">
    <LayoutHeader
      v-if="headerCovered"
      :messageShow="messageShow"
      :shrink="shrink"
      :shortcuts="shortcuts"
      :defaultShortcutsShow="defaultShortcutsShow"
      :colorPickerShow="colorPickerShow"
      :showOrganizationDate="showOrganizationDate"
      :showOrganization="showOrganization"
      :currentDate="currentDate"
      :userOptions="userOptions"
      @on-user="onUser"
      @on-shrink="onShrink"
      @on-shortcut="onShortcut"
    >
      <slot name="headerRight"></slot>
      <template #baner>
        <LayoutBaner class="pg-layout-main__banner" headerCovered></LayoutBaner>
      </template>
      <template #center>
        <slot name="center"></slot>
      </template>
    </LayoutHeader>
    <div class="pg-layout-main__box">
      <LayoutMenu :menuList="menuList" :collapse="shrink">
        <LayoutBaner
          class="pg-layout-main__box-banner"
          :shrink="shrink"
          v-if="!headerCovered"
        ></LayoutBaner>
        <layoutMenuShort :menuList="menuList" :collapse="shrink" v-if="showMenuShort" />
      </LayoutMenu>
      <div class="pg-layout-main__right">
        <LayoutHeader
          v-if="!headerCovered"
          :messageShow="messageShow"
          :shrink="shrink"
          :shortcuts="shortcuts"
          :defaultShortcutsShow="defaultShortcutsShow"
          :colorPickerShow="colorPickerShow"
          :showOrganizationDate="showOrganizationDate"
          :showOrganization="showOrganization"
          :currentDate="currentDate"
          :userOptions="userOptions"
          @on-user="onUser"
          @on-shrink="onShrink"
          @on-shortcut="onShortcut"
        >
          <slot name="headerRight"></slot>
          <template #center>
            <slot name="center"></slot>
          </template>
        </LayoutHeader>
        <LayoutTab
          :menuList="openMenuList"
          :activeMenu="currentRouter"
          @on-command="onCommand"
          @on-change="onTabChange"
          @on-refresh="onRefresh"
          @on-close="onClose"
          @on-sortable="onSortable"
        ></LayoutTab>
        <div class="pg-layout-main__router" id="layoutTemplate_single_page_con">
          <transition name="el-fade-in-linear" mode="out-in">
            <keep-alive :include="keepAliveInclude" max="10">
              <router-view v-if="routerViewShow" :key="routerName" id="routerView"></router-view>
            </keep-alive>
          </transition>
        </div>
        <div class="pg-layout-main__copyright" v-if="solution">
          <p class="pg-layout-main__copyright-left">
            <span>{{ solution.copyright }}</span>
            <span>{{ solution.certificate }}</span>
          </p>
          <p class="pg-layout-main__copyright-right">
            <slot name="footRight"></slot>
            <img :src="solution?.icon || logoImg" />{{ solutionName }}-{{ systemName }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import LayoutHeader from './layout-header.vue'
import LayoutMenu from './layout-menu.vue'
import layoutMenuShort from './layout-menu-short.vue'
import LayoutTab from './layout-tab.vue'
import LayoutBaner from './layout-baner.vue'
import logoImg from '../../../static/image/logo.png'
import { getCurrentInstance, ref, computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import { useTab } from '../hook/use-tab'
import { useMenuList } from '../hook/use-menu-list'
const emit = defineEmits(['refrash', 'on-shortcut', 'on-user'])
const props = defineProps({
  //获取菜单的接口地址
  menuListUrl: String,
  //是否显示全部菜单按钮
  showMenuShort: Boolean,
  //可支持的快捷操作选项
  shortcuts: Array,
  //是否显示默认的快捷选项（APP下载）
  defaultShortcutsShow: {
    type: Boolean,
    default: true,
  },
  //是否显示消息中心
  messageShow: {
    type: Boolean,
    default: false,
  },
  //是否显示自定义主题色
  colorPickerShow: {
    type: Boolean,
    default: true,
  },
  //顶部栏是否铺满
  headerCovered: {
    type: Boolean,
    default: true,
  },
  //是否显示组织
  showOrganization: Boolean,
  //是否显示有效期
  showOrganizationDate: Boolean,
  //是否显示当前日期
  currentDate: Boolean,
  userOptions: Array,
})

const route = useRoute()
const { proxy } = getCurrentInstance()

//菜单栏收起/展开
const shrink = ref(false)
const onShrink = () => {
  shrink.value = !shrink.value
}
const onUser = (val) => {
  emit('on-user', val)
}
const onShortcut = (val) => {
  emit('on-shortcut', val)
}
//左侧菜单
const { menuList } = useMenuList(props.menuListUrl)

//tab区域
const {
  openMenuList,
  currentRouter,
  onCommand,
  onTabChange,
  onClose,
  routerViewShow,
  onRefresh,
  onSortable,
} = useTab(emit)

const keepAliveInclude = computed(() => proxy.$store.state.menuStore.keepAliveInclude)
const routerName = computed(() => route.name)

//copyright
const solution = computed(() => proxy.$store.state.user.solution)
const solutionName = computed(() => solution.value?.title || '盘谷')
const systemName = computed(() => proxy.$store.state.user.system?.name || proxy.GLOBAL.SYSTEMNAME)
</script>
<style lang="scss">
@import '../style/layout-main.scss';
</style>
